export interface AppLayoutState {
  workspaceName: string;
}

export const initialAppLayoutState: AppLayoutState = { workspaceName: '' };

export type AppLayoutAction = { type: 'UPDATE_WORKSPACE_NAME'; payload: { workspaceName: string } };
export type AppLayoutReducer = React.Reducer<AppLayoutState, AppLayoutAction>;

export const appLayoutReducer: AppLayoutReducer = ( prevState, action ) => {
  switch ( action.type ) {
    case 'UPDATE_WORKSPACE_NAME': {
      const { workspaceName } = action.payload;
      return {
        ...prevState,
        workspaceName,
      };
    }
    default:
      return prevState;
  }
};
